import { baseClient, API } from "../index";

export const getQuizById = async (id) => {
	return baseClient().get(`${API}/quiz/${id}`);
};
